import Vue from 'vue'
import _ from 'lodash'
import { v4 as uuid } from 'uuid';

const oracles = require('@/helpers/oracles.json')

const oracle = {
  namespaced: true,
  state: {
    oraclesCategories: [
      {
        name: 'adventure',
      },
    ],

    oracles: [
    ],
  },

  getters: {
    allOracles(state) {
      return state.oracles;
    },
    oracleByID: state => oracleID => {
      return _.find(state.oracles, {id: oracleID});
    },
  },

  mutations: {
    setOracles(state, oracles) {
      state.oracles = oracles;
    }
  },

  actions: {
    initialize({ commit }) {
      commit('setOracles', oracles)
    },

    ask({getters,  commit}, payload) {
      const oracleResult = Vue.rolling.oracleRoll(100)
      const oracle = getters.oracleByID(payload.oracleID)
      const result = {
        oracleTitle: oracle.title,
        result: oracle.table[oracleResult],
      }

      const entry = {
        uuid: uuid(),
        entryType: 'oracle',
        result: result,
        createdAt: new Date().getTime(),
      }
      commit('log/addOracleEntry', entry, { root: true })
    },

  },
}

export default oracle;
